export default __webpack_public_path__ + "static/lumiq-1be7791e1df183939bcd6d1f67eae916.svg";